
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/ulcer-management-lang",
      function () {
        return require("private-next-pages/[lang]/ulcer-management-lang/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/ulcer-management-lang"])
      });
    }
  